<template>
  <div class="reportPhotos">
    <h1>{{ $t("reportPhotos.title") }}</h1>
    <v-client-table
      :columns="table_options.columns"
      :options="table_options.options"
      :data="photosItem"
    >
      <template #photoUpload="props">
        <div v-if="props.row.chatPicture === ''" class="gray">
          <span>No Image</span>
        </div>
        <img
          v-else
          class="image-group"
          @click="openModal(props.row)"
          :src="props.row.chatPicture"
        />
      </template>
      <template #deletePhoto="props">
        <button @click="deleteModal(props.row)" class="deletePhotoBtn btn">
          {{ $t("reportPhotos.deletePhotoBtn") }}
        </button>
      </template>
    </v-client-table>
    <!-- Modal -->
    <Modal
      v-if="modalActive"
      :class="isDeleteModal ? 'deleteModal' : ''"
      @closeModal="closeModal"
    >
      <template #header>
        <h6 v-if="isDeleteModal">{{ $t("reportPhotos.attention") }}</h6>
      </template>
      <template>
        <div
          v-if="!isDeleteModal"
          class="imgModal"
          :style="{ 'background-image': `url(${imageObject.chatPicture})` }"
        ></div>
        <p v-if="!isDeleteModal" class="p-2">
          {{ $t("reportPhotos.photoOf") }}:
          <span>{{ imageObject.photoBelongTo }}</span>
        </p>
        <p v-if="isDeleteModal">{{ $t("reportPhotos.modalAlertTitle") }}</p>
        <p v-if="isDeleteModal">{{ $t("reportPhotos.modalAlertSubtitle") }}</p>
      </template>
      <template #footer>
        <div v-if="isDeleteModal" class="controls">
          <span class="control cancel-btn mr-3" @click="closeModal">{{
            $t("news.details.modal.cancel")
          }}</span>
          <span class="control cancel-btn" @click="deleteImage">{{
            $t("groups.deletePhoto")
          }}</span>
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import API_SERVICE from "@/lib/api/reportPhotos.js";
import S3_Handler from "@/lib/api/s3_handler";
const s3 = new S3_Handler();
const api = new API_SERVICE();
const Modal = () => import("@/components/Modal");

import moment from "moment";
export default {
  components: {
    Modal
  },
  data() {
    return {
      photosItem: null,
      modalActive: false,
      imageObject: null,
      isDeleteModal: false
    };
  },

  async beforeMount() {
    await this.getPhotos();
  },
  methods: {
    openModal: function(imgObj) {
      this.modalActive = true;
      this.imageObject = imgObj;
    },
    deleteModal(imgObj) {
      this.modalActive = true;
      this.imageObject = imgObj;
      this.isDeleteModal = true;
    },
    closeModal: function() {
      this.modalActive = false;
      this.isDeleteModal = false;
    },
    async deleteImage() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        let data = {
          controlNumber: this.imageObject.controlNumber
        };
        const response = await api.deleteUserPhoto(data);
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
        await this.getPhotos();
        this.closeModal();
      }
    },
    async getPhotos() {
      this.$store.commit("global/SET_LOADING", true);
      try {
        const response = await api.getReportedUsers();
        for (let index = 0; index < response.users.length; index++) {
          //Asignacion de usuario con toda su info
          response.users[index].photoBelongTo =
            response.users[index].name +
            " " +
            response.users[index].lastName +
            " " +
            response.users[index].mothersLastName +
            "," +
            response.users[index].uo +
            "," +
            response.users[index].controlNumber;
          //Asignacion de quien reporto la imagen
          response.users[index].reportBy =
            response.users[index].reportedName +
            " " +
            response.users[index].reportedLastName +
            " " +
            response.users[index].reportedMothersLastName +
            "," +
            response.users[index].reportedUo +
            "," +
            response.users[index].reportedControlNumber;
          //dar formato a fecha de reporte
          let formatDate = moment(
            response.users[index].imageReportedDate
          ).format("DD/MM/YY, HH:mm a");
          response.users[index].dateReport = formatDate;
          //Validar si viene imagen
          if (response.users[index].chatPicture) {
            const signedUrl = s3.getSignedUrl(
              response.users[index].chatPicture
            );
            response.users[index].chatPicture = signedUrl;
          } else {
            response.users[index].chatPicture = "";
          }
        }

        this.photosItem = response.users;
      } catch (error) {
        console.log(error);
        this.$store.commit("global/SET_LOADING", false);
      } finally {
        this.$store.commit("global/SET_LOADING", false);
      }
    }
  },
  computed: {
    table_options: function() {
      return {
        columns: [
          "reportBy",
          "dateReport",
          "photoBelongTo",
          "photoUpload",
          "deletePhoto"
        ],
        options: {
          filterByColumn: false,
          filterable: [""],
          headings: {
            reportBy: this.$t("reportPhotos.table.headings.reportBy"),
            dateReport: this.$t("reportPhotos.table.headings.dateReport"),
            photoBelongTo: this.$t("reportPhotos.table.headings.photoBelongTo"),
            photoUpload: this.$t("reportPhotos.table.headings.photoUpload"),
            deletePhoto: this.$t("reportPhotos.table.headings.deletePhoto")
          },
          sortable: ["reportBy", "dateReport", "photoBelongTo"],
          sortIcon: {
            base: "fas",
            up: "fa-sort-up",
            down: "fa-sort-down",
            is: "fa-sort"
          },
          perPage: 10,
          columnsClasses: {
            reportBy: "reportBy-column",
            dateReport: "dateReport-column",
            photoBelongTo: "photoBelongTo-column",
            photoUpload: "photoUpload-column",
            deletePhoto: "deletePhoto-column"
          },
          resizableColumns: false
        }
      };
    }
  }
};
</script>

<style>
.form-inline label {
  display: initial;
}
.deletePhoto-column {
  width: 240px !important;
}
.deletePhotoBtn {
  background-color: #000 !important;
  border-radius: 0px !important;
  padding: 1rem 2rem !important;
  color: #fff !important;
}
.deletePhotoBtn:hover {
  background-color: #000;
  color: #fff;
}
.reportPhotos .VueTables__search {
  display: none !important;
}
.gray {
  background-color: #cccccc;
  height: 100px;
  width: 150px;
  margin-right: auto;
  margin-left: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.image-group {
  width: 150px;
  height: 100px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  cursor: pointer;
}
.table td {
  vertical-align: middle;
}
.table {
  text-align: center !important;
  justify-content: center;
}
.imgModal {
  width: 35rem;
  height: 25rem;
  background-position: center;
  background-size: cover;
}
.reportPhotos .modal-container {
  max-width: 45rem !important;
  max-height: 60rem !important;
}
.reportPhotos .deleteModal .modal-container {
  max-width: 30rem !important;
  max-height: 50rem !important;
}
.reportPhotos .deleteModal .modal-container footer {
  display: initial;
}
.controls {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
.controls span {
  cursor: pointer;
}
.reportPhotos .modal-container footer {
  display: none;
}
</style>
